import * as React from "react";
// NEW: Import hooks for state, side-effects, and routing context
import { useState } from "react";
import { useEffect } from "react";
// NEW: Import Outlet and hooks for navigation/location
import { createBrowserRouter, redirect, RouterProvider, Outlet, useLocation, useNavigate } from "react-router-dom";

import { StatsigProvider } from "@statsig/react-bindings";
import { GetFranchiseByName } from "../Api";
import ReactGA from "react-ga4";
import { CssVarsProvider, extendTheme } from "@mui/joy";

import LandingRoof from "./roof_landing/LandingRoof";
import VideoModal from "./modals/VideoModal";
const IMAGE_PATH = '/images/';


const theme = extendTheme({
    colorSchemes: {
        light: {
            palette: {
                primary: {
                    50: '#001D83',
                    100: '#001D83',
                    200: '#001D83',
                    300: '#001D83',
                    400: '#001D83',
                    500: '#001D83',
                    600: '#001D83',
                    700: '#001D83',
                    800: '#001D83',
                    900: '#001D83',
                },
            },
        },
    },
});

// A helper function to avoid repeating the loader logic
const franchiseLoader = async ({ request, params }) => {
    const url = new URL(request.url);
    const searchTerm = url.searchParams.get("location");
    try {
        if (params.franchise) {
            const franchise = await GetFranchiseByName(
                `${params.franchise.toLowerCase().replaceAll('-', '_')}`,
                searchTerm
            ).then(res => res as Franchise);
            return { franchise };
        }
    } catch (error) {
        console.error("Failed to load franchise:", error);
    }
    return null;
};

const redirectToRoof = async ({ request }) => {
    const url = new URL(request.url);
    return redirect(`/roof${url.search}`);
};

// NEW: This component will wrap your pages, check the URL, and display the modal.
// It's defined here to avoid creating a new file.
const Root = () => {
    // !!! IMPORTANT: Change this to the base URL where your videos are hosted.
    const VIDEO_BASE_URL = 'https://yeti-clean-media.lon1.cdn.digitaloceanspaces.com/';

    const location = useLocation();
    const navigate = useNavigate();
    const [modalVideoUrl, setModalVideoUrl] = useState(null);

    // This effect runs whenever the URL changes
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const videoId = searchParams.get('video_id');

        if (videoId) {
            // Construct the full URL and open the modal
            setModalVideoUrl(`${VIDEO_BASE_URL}${videoId}`); // Assumes .mp4 extension
        } else {
            // Close the modal if the param is not present
            setModalVideoUrl(null);
        }
    }, [location.search]); // Dependency array ensures this runs only when the query string changes

    const handleCloseModal = () => {
        // Create a fresh copy of the search params from the current URL
        const searchParams = new URLSearchParams(location.search);
        // Remove the video_id param
        searchParams.delete('video_id');
        // Navigate to the same page but with the cleaned URL, without adding to browser history
        navigate({ search: searchParams.toString() }, { replace: true });
    };

    return (
        <>
            {/* Outlet is the placeholder where your actual page component (Landing, etc.) will be rendered */}
            <Outlet />

            {/* The modal lives here, outside the page content, controlled by its state */}
            <VideoModal
                open={!!modalVideoUrl}
                onClose={handleCloseModal}
                videoUrl={modalVideoUrl}
            />
        </>
    );
};

export default function App() {
    useEffect(() => {
        ReactGA.initialize([
            {
                trackingId: 'AW-16693850742',
            }
        ]);
    }, []);

    const router = createBrowserRouter([
        {
            // NEW: All routes are now children of the "Root" component.
            // This ensures the Root component (and its modal logic) is always active.
            element: <Root />,
            children: [
                {
                    element: <LandingRoof />,
                    path: "roof/:franchise?",
                    loader: franchiseLoader,
                },
                {
                    index: true,
                    loader: redirectToRoof,
                },
                {
                    path: "*",
                    loader: redirectToRoof,
                }
            ]
        }
    ]);

    return (
        <>
            <img style={{ height: "50px", display: "none" }} src={`${IMAGE_PATH}yeti.webp`} alt="" />
            <StatsigProvider sdkKey="client-1LaN5fZ5fbBA1GXsbkJ8mm9WGEZkhEI6kgKwwhpzLwD">
                <CssVarsProvider theme={theme}>
                    <RouterProvider router={router} />
                </CssVarsProvider>
            </StatsigProvider>
        </>
    )
}